export default __webpack_public_path__ + "static/media/microtica-color-logo.0a2df19e.png";